<!-- 产品说明 -->
<style scoped>
.introduce {
    width: 100%;
    background-color: #18191e;
}
.content {
    width: 1200px;
    padding: 35px 0 20px;
    margin: 0 auto;
}
.list {
    display: -webkit-flex;
    display: flex;
    width: 100%;
    padding-bottom: 20px;
    border-bottom: 1px solid #2e3039;
    justify-content: space-between;
    -webkit-justify-content: space-between;
}
.item {
    display: inline-block;
    vertical-align: top;
}
.item.item1 {
    width: 19%;
}
.item.item2 {
    width: 29%;
}
.item.item3 {
    width: 22%;
}
.item h1 {
    width: 100%;
    padding-bottom: 20px;
    margin-bottom: 20px;
    border-bottom: 1px solid #2e3039;
}
.item h1 i {
    vertical-align: middle;
    display: inline-block;
    background-size: 100% 100%;
}
.item h1 i.introduceicon1 {
    width: 21px;
    height: 19px;
    background-image: url(../assets/images/introduceicon1.png);
}
.item h1 i.introduceicon2 {
    width: 22px;
    height: 19px;
    background-image: url(../assets/images/introduceicon2.png);
}
.item h1 i.introduceicon3 {
    width: 21px;
    height: 23px;
    background-image: url(../assets/images/introduceicon3.png);
}
.item h1 i.introduceicon4 {
    width: 22px;
    height: 22px;
    background-image: url(../assets/images/introduceicon4.png);
}
.item h1 span {
    font-weight: normal;
    color: #ffffff;
    font-size: 18px;
}
.item ul {
    width: 100%;
}
.item ul li {
    display: inline-block;
    color: #8d919f;
    font-size: 12px;
    line-height: 30px;
}
.item ul li a {
    color: #8d919f;
}
.item ul li.labelwidth1 {
    width: 50%;
}
.item ul li.labelwidth2 {
    width: 100%;
}
.tips {
    margin-top: 25px;
    text-align: center;
    color: #ffffff;
    font-size: 12px;
}
</style>
<template>
    <div class="introduce">
        <div class="content">
            <div class="list">
                <div 
                    class="item" 
                    v-for="(listItem,listIndex) in list" 
                    :key="listIndex" 
                    :class="{'item1': listIndex === 0 || listIndex === 1,'item2': listIndex === 2,'item3': listIndex === 3}">
                    <h1>
                        <i 
                            :class="{'introduceicon1': listIndex===0,'introduceicon2': listIndex===1,'introduceicon3': listIndex===2,'introduceicon4': listIndex===3}">
                        </i>&nbsp;<span>{{listItem.name}}</span>
                    </h1>
                    <div class="label_box">
                        <ul>
                            <li 
                                v-for="(item,index) in listItem.item" 
                                :key="index" 
                                :class="{
                                    'labelwidth1': (listIndex === 0 || listIndex === 1),
                                    'labelwidth2': (listIndex === 2 || listIndex === 3)
                                }">
                                <a 
                                    v-if="listIndex === 3" 
                                    href="http://www.richinfo.cn/" 
                                    target="_blank">{{item}}</a>
                                <span v-else>{{item}}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <p class="tips">版权所有 © 2020  彩讯科技股份有限公司 | 粤ICP备15050890号-2</p>
        </div>
    </div>
</template>
<script>
export default {
    name: 'introduce',
    data() {
        return {
            list: [
                {
                    name: '产品与服务',
                    item: ['智能机器人','中间号','图像识别','短信小程序','语音识别','内容智能审核','身份认证','自有通道短信回落']
                },
                {
                    name: '解决方案',
                    item: ['电商行业','党政行业','金融行业','工业能源行业','交通行业','医疗行业','教育行业','互联网行业']
                },
                {
                    name: '联系我们',
                    item: ['商务合作：陈经理','联系电话：4008-303-123','工作邮箱：csp@richinfo.cn','办公地址：深圳市南山区科苑南路3176号彩讯科创中心']
                },
                {
                    name: '友情链接',
                    item: ['彩讯官网']
                }
            ]
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/introduce.vue